import React from "react";
import "./CheckInConfirmationModal.css";

const CheckInConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  guestData,
  isLoading,
}) => {
  if (!isOpen) return null;

  return (
    <div className="checkin-confirmation-overlay">
      <div className="checkin-confirmation-container">
        <button onClick={onClose} className="checkin-close-button">
          <span>×</span>
        </button>

        <div className="checkin-confirmation-content">
          <div className="checkin-icon-container">
            <svg
              width="80"
              height="80"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="10" fill="#006216" opacity="0.1" />
              <path
                d="M9 12L11 14L15 10"
                stroke="#006216"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle
                cx="12"
                cy="12"
                r="9"
                stroke="#006216"
                strokeWidth="2"
                fill="none"
              />
            </svg>
          </div>

          <h2 className="checkin-title">Confirm Check-In</h2>

          <div className="checkin-guest-info">
            <div className="guest-info-row">
              <div className="info-icon-label">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
                    fill="#666"
                  />
                </svg>
                <span className="info-label">Guest Name</span>
              </div>
              <span className="info-value">{guestData?.guestName}</span>
            </div>

            {guestData?.guestEmail && (
              <div className="guest-info-row">
                <div className="info-icon-label">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
                      fill="#666"
                    />
                  </svg>
                  <span className="info-label">Email</span>
                </div>
                <span className="info-value">{guestData.guestEmail}</span>
              </div>
            )}

            <div className="guest-info-row">
              <div className="info-icon-label">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10zM5 8V6h14v2H5z"
                    fill="#666"
                  />
                </svg>
                <span className="info-label">Event</span>
              </div>
              <span className="info-value">{guestData?.eventTitle}</span>
            </div>

            <div className="guest-info-row">
              <div className="info-icon-label">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
                    fill="#666"
                  />
                </svg>
                <span className="info-label">Date & Time</span>
              </div>
              <span className="info-value">
                {new Date(guestData?.eventDate).toLocaleDateString()} at{" "}
                {guestData?.eventTime}
              </span>
            </div>

            {guestData?.numberOfGuests && guestData.numberOfGuests > 1 && (
              <div className="guest-info-row">
                <div className="info-icon-label">
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
                      fill="#666"
                    />
                  </svg>
                  <span className="info-label">Number of Guests</span>
                </div>
                <span className="info-value">{guestData.numberOfGuests}</span>
              </div>
            )}

            <div className="guest-info-row status-row">
              <div className="status-badge">
                <span className="status-text">Invitation Accepted</span>
              </div>
            </div>
          </div>

          <div className="checkin-actions">
            <button
              className="checkin-button cancel"
              onClick={onClose}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              className="checkin-button confirm"
              onClick={() => onConfirm(guestData)}
              disabled={isLoading}
            >
              {isLoading ? (
                <>
                  <span className="button-loader"></span>
                  Checking In...
                </>
              ) : (
                "Confirm Check-In"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckInConfirmationModal;